module.exports = __webpack_public_path__ + "img/2.77da7ee2.png";